import React from 'react';
import Checked from 'components/Brand/Icons/static/box-checked.png';
import Unchecked from 'components/Brand/Icons/static/box-unchecked.png';
import { WebsiteImage } from 'components/TitleDescription';

import { TableCard, TableCardTitle, TableProgress } from '../styles';

const TableOfContentsCard = ({ chapter, chapterNumber, progress }) => {
  return (
    <TableCard bordered={false}>
      <TableCardTitle>
        {chapterNumber}. {chapter.title}
      </TableCardTitle>
      <TableProgress>
        {progress.map((section, index) => (
          <WebsiteImage
            key={index}
            className="section-status"
            src={section ? Checked : Unchecked}
            alt="playbook-section-status"
          />
        ))}
      </TableProgress>
    </TableCard>
  );
};

export default TableOfContentsCard;
